export default __webpack_public_path__ + "static/media/login_signup_ic.d7d78038.svg";